import { IPlan } from "../../../../common/types";
import { borderWidth } from "../ExperienceEditor/styles";
import { screenPositions } from "../ExperienceEditor/utils";
import { IClass } from "../../homeworks/interfaces";

export const getDragPositions = ({ plan, screenWidth, screenHeight }: { plan?: IPlan, screenWidth: number, screenHeight: number }) => {
    if (!plan) return null;
    if (!plan.experience.enabled) return null;
    let iconX = screenWidth / 12;
    let iconY = 0;
    const iconWidth = (screenWidth || 0) / 3;
    const newPositions = plan.tasks.map(() => {
        const added = screenWidth / 3 + screenWidth / 6;
        if (iconX + added > screenWidth * 3 + screenWidth / 12 + 1) {
            iconX = screenWidth / 12;
            iconY += iconWidth * 1.4;
        }
        iconX += added;
        return {
            x: -1,
            y: -1,
        };
    });
    const offset = (screenWidth! + iconWidth) / 6;
    const newDragPositions = newPositions.map((position, index) => {
        const taskId = plan.tasks[index].id;
        let taskPosition = plan.experience.positions.indexOf(taskId);
        let positionOffset = 0;
        if (taskPosition === -1) {
            taskPosition = plan.experience.positions.findIndex(position => {
                if (Array.isArray(position)) {
                    if (position.indexOf(taskId) === 0) {
                        positionOffset = -offset;
                    } else if (position.indexOf(taskId) === 1) {
                        positionOffset = offset;
                    }
                    return position.indexOf(taskId) !== -1
                }
                return false;
            })
        }
        if (taskPosition !== -1) {
            return {
                x: screenWidth * screenPositions[taskPosition!].x - screenPositions[taskPosition!].x * borderWidth
                        + (screenWidth - iconWidth) / 2 + positionOffset,
                y: screenHeight * screenPositions[taskPosition!].y - screenPositions[taskPosition!].y * borderWidth
                    + (screenHeight - iconWidth) / 2,
            }
        }
        return position;
    })
    return newDragPositions;
}

export const parseClasses = (classes: IClass[], addedClasses: string[], addedLabel: string) => {
    return classes.map(c => ({
        label: addedClasses.includes(c._id) ? `${c.name} ${addedLabel}` : c.name,
        value: c._id,
    }));
};